<template>
  <QuoteForm :clone="true" />
</template>

<script>
import QuoteForm from "./Form";

export default {
  components: {
    QuoteForm
  },
 
};
</script>